import api from '../../../../config/api.service';
import Cookies from 'universal-cookie';

class GerenciamentoAplicacao {
    protected cookies = new Cookies();

    async listStatus() {
        const resp = await api.get('listStatus')
            .then((resp) => resp.data)
            .catch((err) => err.response.data.message);

        return resp;
    }

    async desativarStatusById(idStatus: any) {
        const resp = await api.put('desativarStatusById', {idStatus})
            .then((resp) => resp.data)
            .catch((err) => err.response.data.message)

        return resp;
    }

    async createStatus(data: any) {
        const resp = await api.post('createStatus', data)
            .then((resp) => resp.data)
            .catch((err) => err.response.data.message);

        return resp;
    }

}

export default new GerenciamentoAplicacao();
